
  import {Component, Vue} from 'vue-property-decorator';
  import {mapGetters} from "vuex";
  import {ICar} from "@/modules/Car/interfaces/car.interface";
  import CarListCard from "@/modules/CarList/components/CarListCard.vue";
  import CarListEmpty from "@/modules/CarList/components/CarListEmpty.vue";

  @Component({
    components: {
      CarListCard,
      CarListEmpty,
    },
    computed: mapGetters({
      carList: "carList/sortedList",
    })
  })
  export default class CarList extends Vue {
    carList: ICar.IEntity[];

    get loading() { return this.$store.state.carList.loading; }
  }
